export const endPoint = "https://qbmedia.b-cdn.net/caferose"
// https://qbmedia.b-cdn.net/caferose
export const url = "https://card.qbmedia.co.il/"

export const bizNUM = '972525040074'
export const bizNUM2 = '046719669'
export const bizFB = 'rosecafe'
export const bizIG = 'rose.cafe6'
export const bizWEB = 'qbmedia.co.il'
